export const FAMILY_TYPE_REGULAR_ID = '1cfaea12-8496-422d-8706-0dd57c59aac8';
export const FAMILY_TYPE_MONOPARENTAL_ID = '4bc2908f-712d-4cb0-99e1-016df66f8209';
export const FAMILY_TYPE_MONOMARENTAL_ID = '53124c82-40b5-4abf-9f2b-e04058beb63f';

export const FAMILY_TYPE_MONOPARENTALS_IDS = [FAMILY_TYPE_MONOPARENTAL_ID,FAMILY_TYPE_MONOMARENTAL_ID];

export const FAMILY_TYPE_REGULAR_LABEL = 'Familia ordinaria';
export const FAMILY_TYPE_MONOPARENTAL_LABEL = 'Familia monoparental';
export const FAMILY_TYPE_MONOMARENTAL_LABEL = 'Familia monomarental';

export const FAMILY_TYPE_LABELS = {
    [FAMILY_TYPE_REGULAR_ID]: FAMILY_TYPE_REGULAR_LABEL,
    [FAMILY_TYPE_MONOPARENTAL_ID]: FAMILY_TYPE_MONOPARENTAL_LABEL,
    [FAMILY_TYPE_MONOMARENTAL_ID]: FAMILY_TYPE_MONOMARENTAL_LABEL
}
